// Enable IE 11 support
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js';

import React from 'react';
import ReactDOM from 'react-dom';
import StudentPortal from './StudentPortal/studentPortal';
import { UIProvider } from '@qualtrics/ui-react';
import './index.module.css';

ReactDOM.render(
    <UIProvider config={{localizedText: {
        "configPane.showPanel": "Show Table of Contents",
        "configPane.hidePanel": "Hide Table of Contents",
        "configPane.pinPanel": "Pin Table of Contents",
        "configPane.unpinPanel": "Unpin Table of Contents",
    }}}>
        <StudentPortal />
    </UIProvider>,
    document.getElementById('root')
);
